export default __webpack_public_path__ + "static/media/finalistDiploma.9ae212ba.png";